export const DELIVERY = 'DELIVERY';
export const PICKUP = 'PICKUP';

export const MainMenu = 'MainMenu';
export const BreakfastMenu = 'BreakfastMenu';
